import { Box, Button, SvgIcon, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { spaces } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';
import useScreenSize from '../../../utils/useScreenSize';

interface OwnProps {
	stepNum: number;
	totalSteps: number;
	onBack?: () => void;
	onNext: () => void;
	onNextIsDisabled?: boolean;
}

const OnboardingNavigationButtons: React.FC<OwnProps> = ({
	stepNum,
	totalSteps,
	onBack,
	onNext,
	onNextIsDisabled,
}) => {
	const { t } = useTranslation();
	const { isXsScreen } = useScreenSize();
	const nextButtonLabel =
		stepNum !== totalSteps ? t('Next') : isXsScreen ? t('Complete') : t('Complete account creation');

	if (stepNum === 0) {
		return (
			<Box
				sx={{
					marginLeft: isXsScreen ? 0 : spaces.xxxxl,
					marginRight: isXsScreen ? 0 : spaces.xxxxl,
				}}
			>
				<Button
					data-testid="onboarding-step-password-submit-button"
					variant="contained"
					size="large"
					color="primary"
					onClick={onNext}
					disabled={onNextIsDisabled}
					type="button"
					aria-label={t('Continue')}
					sx={{
						width: '100%',
						marginTop: isXsScreen ? 'auto' : 0,
						marginBottom: isXsScreen ? 0 : 'auto',
					}}
				>
					{t('Continue')}
				</Button>
			</Box>
		);
	}

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				width: '100%',
				paddingTop: 'auto',
				paddingBottom: 0,
			}}
		>
			<Button
				variant="text"
				color="secondary"
				size="large"
				sx={{ padding: `${spaces.xs}px ${spaces.lg}px` }}
				onClick={onBack}
				disabled={!onBack}
				type="button"
				aria-label={t('Back')}
				aria-disabled={!onBack}
				startIcon={<SvgIcon component={getMuiIcon('arrowLeft')} aria-hidden="true" />}
			>
				{t('Back')}
			</Button>
			<Typography variant="body2" color="text.primary">
				{stepNum}/{totalSteps}
			</Typography>
			<Button
				variant="contained"
				color="primary"
				size="large"
				sx={{ padding: `${spaces.xs}px ${spaces.lg}px` }}
				onClick={onNext}
				disabled={onNextIsDisabled}
				type="button"
				aria-label={nextButtonLabel}
				aria-disabled={onNextIsDisabled}
			>
				{nextButtonLabel}
			</Button>
		</Box>
	);
};

export default OnboardingNavigationButtons;
